import * as React from 'react';
import { t } from 'i18next';

import { LoadingAnimationProps, LoadingAnimation } from './LoadingAnimation';
import { MessageBoxContent } from './MessageBoxContent';

export interface LoadingCancelableProps {
    label: string;
    cancelCallback: () => void;
    loadingAnimationProps?: LoadingAnimationProps;
}

export class LoadingCancelable extends React.Component<LoadingCancelableProps, {}> {
    public render(): JSX.Element {
        return (
            <MessageBoxContent submitText={t('Cancel')} submitCallback={this.props.cancelCallback}>
                <div className="messagebox-loading">
                    <div className="messagebox-loading-header">
                        <span>{this.props.label}&hellip;</span>
                    </div>
                    <div className="messagebox-loading-main">
                        <LoadingAnimation key="animation" {...this.props.loadingAnimationProps}/>
                    </div>
                </div>
            </MessageBoxContent>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoadingCancelable.tsx